/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * Recyklátor PDF prohlížečů.
 */
class PdfRecycler {
  /**
   * Obnoví PDF prohlížeč do výchozího stavu.
   * Za výchozí se považuje stav,
   * ve kterém je prohlížeč po vytvoření.
   *
   * Neopravuje vlastnost [src](https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/src),
   * protože je tato operace náročná na paměť a je zde vždy možnost,
   * že se bude otevírat stejné PDF.
   * Přijemce má vždy možnost nastavit nové `src` dle potřeby,
   * jistota, že je přechozí hodnota prázdná, není až tak důležitá.
   * @param {PdfParent} parent Rodičovská třída PDF prohlížeče k opravení.
   * @returns {Promise.<undefined>} Vyřeší se, jakmile je prohlížeč opraven.
   */
  recycle(parent) {
    return new Promise((resolve) =>
      resolve(
        parent
          .pause()
          .then(() => parent.setPlaybackRate(1))
          .then(() => parent.setCurrentPage(1))
      )
    );
  }
}

export default PdfRecycler;
